// Application Mutations
export const SET_LOADING = 'SET_LOADING';
export const SET_EVENT_LOADING = 'SET_EVENT_LOADING';
export const SET_TITLE = 'SET_TITLE';
export const INIT_PUSHER = 'INIT_PUSHER';

// User Mutations
export const SET_AUTHORIZED = 'SET_AUTHORIZED';

// Fermenters Mutations
export const SET_FERMENTERS = 'SET_FERMENTERS';
export const SET_ACTIVE_FERMENTER = 'SET_ACTIVE_FERMENTER';
export const ADD_FERMENTER = 'ADD_FERMENTER';

// Ferments Mutations
export const SET_ACTIVE_FERMENT = 'SET_ACTIVE_FERMENT';
export const ADD_FERMENT = 'ADD_FERMENT';
export const SET_FERMENTS = 'SET_FERMENTS';
export const SET_GRAPH_BASE64 = 'SET_GRAPH_BASE64';

// Tank Group Mutations
export const SET_ACTIVE_TANK_GROUP = 'SET_ACTIVE_TANK_GROUP';
export const SET_TANK_GROUPS = 'SET_TANK_GROUPS';
export const ADD_TANK_GROUP = 'ADD_TANK_GROUP';
export const SET_TANK_GROUP_NAME = 'SET_TANK_GROUP_NAME';
export const DESTROY_TANK_GROUP = 'DESTROY_TANK_GROUP';

// Site Mutations
export const SET_SITE = 'SET_SITE';
export const SET_SITES = 'SET_SITES';

// Settings Mutations
export const SET_WHAT_NOW = 'SET_WHAT_NOW';
export const SET_YEAST_TYPES = 'SET_YEAST_TYPES';
export const ADD_YEAST_TYPE = 'ADD_YEAST_TYPE';
export const DESTROY_YEAST_TYPE = 'DESTROY_YEAST_TYPE';
export const UPDATE_YEAST_TYPE = 'UPDATE_YEAST_TYPE';
export const SET_REGIONS = 'SET_REGIONS';
export const ADD_REGION = 'ADD_REGION';
export const DESTROY_REGION = 'DESTROY_REGION';
export const UPDATE_REGION = 'UPDATE_REGION';
export const SET_VARIETALS = 'SET_VARIETALS';
export const ADD_VARIETAL = 'ADD_VARIETAL';
export const DESTROY_VARIETAL = 'DESTROY_VARIETAL';
export const UPDATE_VARIETAL = 'UPDATE_VARIETAL';
export const SET_COUNTRIES = 'SET_COUNTRIES';

// Simulator Setup Mutations
export const SET_SIMULATOR_SETUP = 'SET_SIMULATOR_SETUP';

// Fermenter Profiles
export const SET_PROFILES = 'SET_PROFILES';
export const SET_ACTIVE_PROFILE = 'SET_ACTIVE_PROFILE';
export const ADD_PROFILE = 'ADD_PROFILE';

// Simulator
export const SET_SIMULATOR_RUNNING = 'SET_SIMULATOR_RUNNING';



// WEBPACK FOOTER //
// ./src/vuex/mutation-types.js